import 'core-js/stable';
import 'regenerator-runtime/runtime';
import FontFaceObserver from 'fontfaceobserver';
import { importDynamicTheme, IaTheme, render as renderCore, Theme } from 'ia-react-core';
import { GetDealersExperience } from './utils/dealerUtils';
import ConfiguredApp from './app';
import { AppProps } from './app/App';
import Constants from './app/Constants';

const render = (theme: IaTheme) => {
  const appProps: AppProps = { theme };
  renderCore(ConfiguredApp, appProps);
};

const montserrat = new FontFaceObserver('Montserrat');
const openSans = new FontFaceObserver('Open Sans');
// note le dynamique rajoute tous seul "Theme" a la fin

const localThemes = {
  hyundai: 'designSystem',
  unifi: 'designSystem',
  acura: 'designSystem',
  honda: 'designSystem',
  genesis: 'designSystem',
} as const;

type LocalTheme = keyof typeof localThemes;

const dealersExperiences = {
  ia: 'ia',
  bnt: 'bnt',
  designSystem: 'designSystem',
  investia: 'investia',
} as const;

type CoreTheme = keyof typeof dealersExperiences;
const cachedDealerExperience = GetDealersExperience();
const defaultedDealerExperience = (
  dealersExperiences[cachedDealerExperience as CoreTheme] ||
  localThemes[cachedDealerExperience as LocalTheme]
) ? cachedDealerExperience : Constants.DealersExperience.unifi;

const codeExperience: CoreTheme = (
  dealersExperiences[defaultedDealerExperience as CoreTheme] ||
  localThemes[defaultedDealerExperience as LocalTheme]
);

// eslint-disable-next-line @typescript-eslint/no-floating-promises
Promise.all([
  importDynamicTheme(codeExperience),
  localThemes[cachedDealerExperience as LocalTheme] ? import(`./themes/${cachedDealerExperience}Theme`) : null,
  montserrat.load(),
  openSans.load(),
]).then(([experience, localTheme]: [IaTheme, { default: Theme } | null, void, void]) => {
  render(localTheme?.default || experience);
});
